import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";
import * as settings from "../constants/settings";
import * as componentTypes from "../constants/componentTypes";

export const exportSettings = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_EXPORT_SETTINGS
    },
    method: handlers.EXPORT_SETTINGS,
    tabId: 0
});

export const importSettings = (dataJson) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_IMPORT_SETTINGS,
        params: {
            dataJson: dataJson
        }
    },
    method: handlers.IMPORT_SETTINGS,
    tabId: 0
});

export const restoreSettings = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_RESTORE_SETTINGS
    },
    method: handlers.RESTORE_SETTINGS,
    tabId: 0
});

export const exportStaticSql = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_EXPORT_STATIC_SQL
    },
    method: handlers.EXPORT_STATIC_SQL,
    tabId: 0
});

const getSettingRequest = (key, value, callback) => {
    return {
        type: actionTypes.SERVER_REQUEST,
        payload: {
            type: methods.METHOD_SET_USER_SETTING,
            params: {
                key: key,
                value: value
            }
        },
        method: handlers.SETTINGS_SET_VALUE,
        tabId: componentTypes.NO_SKIP_TAB_ID,
        next: {
            key: key,
            getHandler: handlers.SETTINGS_GET_VALUE,
            callback: callback
        }
    };
};

export const getSettingSetRequest = (key, value, getHandler) => {
    return {
        type: actionTypes.SERVER_REQUEST,
        payload: {
            type: methods.METHOD_SET_USER_SETTING,
            params: {
                key: key,
                value: value
            }
        },
        method: handlers.SETTINGS_SET_VALUE,
        tabId: componentTypes.NO_SKIP_TAB_ID,
        next: {
            key: key,
            getHandler: getHandler,
            callback: null
        }
    };
};

export const getSettingGetRequest = (key, saveAction) => {
    return {
        type: actionTypes.SERVER_REQUEST,
        payload: {
            type: methods.METHOD_GET_USER_SETTINGS,
            params: {
                key: key
            }
        },
        method: handlers.SETTINGS_GET_VALUE,
        tabId: componentTypes.NO_SKIP_TAB_ID,
        next: saveAction
    };
};

export const getSingleSetRequest = (key, value, handler) => {
    return {
        type: actionTypes.SERVER_REQUEST,
        payload: {
            type: methods.METHOD_SET_USER_SETTING,
            params: {
                key: key,
                value: value
            }
        },
        method: handler,
        tabId: componentTypes.NO_SKIP_TAB_ID
    };
};

export const setAdditionalTabType = (value) =>
    getSettingRequest(settings.ADDITIONAL_TAB_TYPE, value, actionTypes.SETTINGS_SAVE_ADDITIONAL_TAB_TYPE);

export const setAlternativeFormulasPosition = (value) =>
    getSettingRequest(
        settings.ALTERNATIVE_FORMULAS_POSITION,
        value,
        actionTypes.SETTINGS_SAVE_ALTERNATIVE_FORMULAS_POSITION
    );

export const setAutoCloseTab = (value) =>
    getSettingRequest(settings.AUTO_CLOSE_TAB, value, actionTypes.SETTINGS_SAVE_AUTO_CLOSE_TAB);

export const setAutomaticClientStart = (value) =>
    getSettingRequest(settings.AUTOMATIC_CLIENT_START, value, actionTypes.SETTINGS_SAVE_AUTOMATIC_CLIENT_START);

export const setAutomaticLogout = (value) =>
    getSettingRequest(settings.AUTOMATIC_LOGOUT, value, actionTypes.SETTINGS_SAVE_AUTOMATIC_LOGOUT);

export const setAutomaticLogoutTimeout = (value) =>
    getSettingRequest(settings.AUTOMATIC_LOGOUT_TIMEOUT, value, actionTypes.SETTINGS_SAVE_AUTOMATIC_LOGOUT_TIMEOUT);

export const setAutomaticPrint = (value) =>
    getSettingRequest(settings.AUTOMATIC_PRINT, value, actionTypes.SETTINGS_SAVE_AUTOMATIC_PRINT);

export const setBarcodesEnabled = (value) =>
    getSettingRequest(settings.BARCODES_ENABLED, value, actionTypes.SETTINGS_SAVE_BARCODES_ENABLED);

export const setBlendFormulaAndCode = (value) =>
    getSettingSetRequest(settings.BLEND_FORMULA_AND_CODE, value, handlers.SETTINGS_GET_BLEND_FORMULA_AND_CODE);

export const setBuildingSite = (value) =>
    getSettingRequest(settings.BUILDING_SITE, value, actionTypes.SETTINGS_SAVE_BUILDING_SITE);

export const setCleaningTime = (value) =>
    getSettingRequest(settings.CLEANING_TIME, value, actionTypes.SETTINGS_SAVE_CLEANING_TIME);

export const setColorantBatchForMultipleCans = (value) =>
    getSettingRequest(
        settings.COLORANT_BATCH_FOR_MULTIPLE_CANS,
        value,
        actionTypes.SETTINGS_SAVE_COLORANT_BATCH_FOR_MULTIPLE_CANS
    );

export const setColorantBatchNumberLogic = (value) =>
    getSettingRequest(
        settings.COLORANT_BATCH_NUMBER_LOGIC,
        value,
        actionTypes.SETTINGS_SAVE_COLORANT_BATCH_NUMBER_LOGIC
    );

export const setColorantPanelLimit = (value) =>
    getSettingRequest(settings.COLORANT_PANEL_LIMIT, value, actionTypes.SETTINGS_SAVE_COLORANT_PANEL_LIMIT);

export const setColorantPanelOrderBy = (value) =>
    getSettingRequest(settings.COLORANT_PANEL_ORDER_BY, value, actionTypes.SETTINGS_SAVE_COLORANT_PANEL_ORDER_BY);

export const setColorPreviewAsImage = (value) =>
    getSettingRequest(settings.COLOR_PREVIEW_AS_IMAGE, value, actionTypes.SETTINGS_SAVE_COLOR_PREVIEW_AS_IMAGE);

export const setColorPreviewResizable = (value) =>
    getSettingRequest(settings.COLOR_PREVIEW_RESIZABLE, value, actionTypes.SETTINGS_SAVE_COLOR_PREVIEW_RESIZABLE);

export const setColorTabCompatibleOnly = (value) =>
    getSettingSetRequest(settings.COLOR_TAB_COMPATIBLE_ONLY, value, handlers.SETTINGS_GET_COLOR_TAB_COMPATIBLE_ONLY);

export const setColorTabFormulaCode = (value) =>
    getSettingRequest(settings.COLOR_TAB_FORMULA_CODE, value, actionTypes.SETTINGS_SAVE_COLOR_TAB_FORMULA_CODE);

export const setColorTabFormulaName = (value) =>
    getSettingRequest(settings.COLOR_TAB_FORMULA_NAME, value, actionTypes.SETTINGS_SAVE_COLOR_TAB_FORMULA_NAME);

export const setColorTabNoteIcons = (value) =>
    getSettingSetRequest(settings.COLOR_TAB_NOTE_ICONS, value, handlers.SETTINGS_GET_COLOR_TAB_NOTE_ICONS);

export const setColorTabOrderBy = (value) =>
    getSettingSetRequest(settings.COLOR_TAB_ORDER_BY, value, handlers.SETTINGS_GET_COLOR_TAB_ORDER_BY);

export const setColorTabRowCount = (value) =>
    getSettingSetRequest(settings.COLOR_TAB_ROW_COUNT, value, handlers.SETTINGS_GET_COLOR_TAB_ROW_COUNT);

export const setColorTabWarningIcon = (value) =>
    getSettingRequest(settings.COLOR_TAB_WARNING_ICON, value, actionTypes.SETTINGS_SAVE_COLOR_TAB_WARNING_ICON);

export const setCompetitiveColorSearch = (value) =>
    getSettingRequest(settings.COMPETITIVE_COLOR_SEARCH, value, actionTypes.SETTINGS_SAVE_COMPETITIVE_COLOR_SEARCH);

export const setCustomBannerPosition = (value) =>
    getSettingSetRequest(settings.CUSTOM_BANNER_POSITION, value, handlers.SETTINGS_GET_POSITION_AND_LOAD_BANNER_LIST);

export const setCustomCanOption = (value) =>
    getSettingSetRequest(settings.CUSTOM_CAN_OPTION, value, handlers.SETTINGS_GET_CUSTOM_CAN_OPTION);

export const setCustomCanSettingsUnitGrav = (value) =>
    getSettingRequest(
        settings.CUSTOM_CAN_SETTINGS_UNIT_GRAV,
        value,
        actionTypes.SETTINGS_SAVE_CUSTOM_CAN_SETTINGS_UNIT_GRAV
    );

export const setCustomCanSettingsUnitVol = (value) =>
    getSettingRequest(
        settings.CUSTOM_CAN_SETTINGS_UNIT_VOL,
        value,
        actionTypes.SETTINGS_SAVE_CUSTOM_CAN_SETTINGS_UNIT_VOL
    );

export const setCustomCanSize = (value) =>
    getSettingRequest(settings.CUSTOM_CAN_SIZE, value, actionTypes.SETTINGS_SAVE_CUSTOM_CAN_SIZE);

export const setCustomCanUnits = (value) =>
    getSettingRequest(settings.CUSTOM_CAN_UNITS, value, actionTypes.SETTINGS_SAVE_CUSTOM_CAN_UNITS);

export const setCustomersEnabled = (value) =>
    getSettingRequest(settings.CUSTOMERS_ENABLED, value, actionTypes.SETTINGS_SAVE_CUSTOMERS_ENABLED);

export const setCustomFormatCurrency = (value) =>
    getSettingRequest(settings.CUSTOM_FORMAT_CURRENCY, value, actionTypes.SETTINGS_SAVE_CUSTOM_FORMAT_CURRENCY);

export const setCustomFormatDate = (value) =>
    getSettingRequest(settings.CUSTOM_FORMAT_DATE, value, actionTypes.SETTINGS_SAVE_CUSTOM_FORMAT_DATE);

export const setCustomFormatNumber = (value) =>
    getSettingRequest(settings.CUSTOM_FORMAT_NUMBER, value, actionTypes.SETTINGS_SAVE_CUSTOM_FORMAT_NUMBER);

export const setCustomFormatTime = (value) =>
    getSettingRequest(settings.CUSTOM_FORMAT_TIME, value, actionTypes.SETTINGS_SAVE_CUSTOM_FORMAT_TIME);

export const setCustomFormulaForMasterProduct = (value) =>
    getSettingRequest(
        settings.CUSTOM_FORMULA_FOR_MASTER_PRODUCT,
        value,
        actionTypes.SETTINGS_SAVE_CUSTOM_FORMULA_FOR_MASTER_PRODUCT
    );

export const setCustomFormulaForMasterProductDefault = (value) =>
    getSettingRequest(
        settings.CUSTOM_FORMULA_FOR_MASTER_PRODUCT_DEFAULT,
        value,
        actionTypes.SETTINGS_SAVE_CUSTOM_FORMULA_FOR_MASTER_PRODUCT_DEFAULT
    );

export const setCustomFormulas = (value) =>
    getSettingRequest(settings.CUSTOM_FORMULAS, value, actionTypes.SETTINGS_SAVE_CUSTOM_FORMULAS);

export const setCustomHomeButton = (value) =>
    getSettingRequest(settings.CUSTOM_HOME_BUTTON, value, actionTypes.SETTINGS_SAVE_CUSTOM_HOME_BUTTON);

export const setDeleteConfirmation = (value) =>
    getSettingRequest(settings.DELETE_CONFIRMATION, value, actionTypes.SETTINGS_SAVE_DELETE_CONFIRMATION);

export const setDiskSpaceNotification = (value) =>
    getSettingRequest(settings.DISK_SPACE_NOTIFICATION, value, actionTypes.SETTINGS_SAVE_DISK_SPACE_NOTIFICATION);

export const setDispensingEnabled = (value) =>
    getSettingRequest(settings.DISPENSING_ENABLED, value, actionTypes.SETTINGS_SAVE_DISPENSING_ENABLED);

export const setDispensingNotesEnabled = (value) =>
    getSettingRequest(settings.DISPENSING_NOTES, value, actionTypes.SETTINGS_SAVE_DISPENSING_NOTES);

export const setDispensingWithErrorsEnabled = (value) =>
    getSettingRequest(
        settings.DISPENSING_WITH_ERRORS_ENABLED,
        value,
        actionTypes.SETTINGS_SAVE_DISPENSING_WITH_ERRORS_ENABLED
    );

export const setEditColorantAllowance = (value) =>
    getSettingRequest(settings.EDIT_COLORANT_ALLOWANCE, value, actionTypes.SETTINGS_SAVE_EDIT_COLORANT_ALLOWANCE);

export const setFileTransfer = (value) =>
    getSettingRequest(settings.FILE_TRANSFER, value, actionTypes.SETTINGS_SAVE_FILE_TRANSFER);

export const setFileTransferInTasks = (value) =>
    getSettingRequest(settings.FILE_TRANSFER_IN_TASKS, value, actionTypes.SETTINGS_SAVE_FILE_TRANSFER_IN_TASKS);

export const setFileTransferOutTasks = (value) =>
    getSettingRequest(settings.FILE_TRANSFER_OUT_TASKS, value, actionTypes.SETTINGS_SAVE_FILE_TRANSFER_OUT_TASKS);

export const setFormulaAutomaticNaming = (value) =>
    getSettingRequest(settings.FORMULA_AUTOMATIC_NAMING, value, actionTypes.SETTINGS_SAVE_FORMULA_AUTOMATIC_NAMING);

export const setFormulaCode = (value) =>
    getSettingSetRequest(settings.FORMULA_CODE, value, handlers.SETTINGS_GET_FORMULA_CODE);

export const setFormulaCodePrimary = (value) =>
    getSettingRequest(settings.FORMULA_CODE_PRIMARY, value, actionTypes.SETTINGS_SAVE_FORMULA_CODE_PRIMARY);

export const setFormulaColorPreview = (value) =>
    getSettingRequest(settings.FORMULA_COLOR_PREVIEW, value, actionTypes.SETTINGS_SAVE_FORMULA_COLOR_PREVIEW);

export const setFormulaInfoData = (value) =>
    getSettingRequest(settings.FORMULA_INFO_DATA, value, actionTypes.SETTINGS_SAVE_INFO_DATA);

export const setFormulaInfoInRgbPreview = (value) =>
    getSettingRequest(
        settings.FORMULA_INFO_ITEM_IN_RGB_PREVIEW,
        value,
        actionTypes.SETTINGS_SAVE_INFO_ITEM_IN_RGB_PREVIEW
    );

export const setFormulaModificationPanel = (value) =>
    getSettingRequest(settings.FORMULA_MODIFICATION_PANEL, value, actionTypes.SETTINGS_SAVE_FORMULA_MODIFICATION_PANEL);

export const setFormulaName = (value) =>
    getSettingSetRequest(settings.FORMULA_NAME, value, handlers.SETTINGS_GET_FORMULA_NAME);

export const setFormulaNotesEnabled = (value) =>
    getSettingRequest(settings.FORMULA_NOTES, value, actionTypes.SETTINGS_SAVE_FORMULA_NOTES);

export const setFormulaPreview = (value) =>
    getSettingRequest(settings.FORMULA_PREVIEW, value, actionTypes.SETTINGS_SAVE_FORMULA_PREVIEW);

export const setFormulaPropertiesPosition = (value) =>
    getSettingRequest(
        settings.FORMULA_PROPERTIES_POSITION,
        value,
        actionTypes.SETTINGS_SAVE_FORMULA_PROPERTIES_POSITION
    );

export const setFormulaStatusPanel = (value) =>
    getSettingRequest(settings.FORMULA_STATUS_PANEL, value, actionTypes.SETTINGS_SAVE_FORMULA_STATUS_PANEL);

export const setFormulaUnits = (value) =>
    getSettingRequest(settings.FORMULA_UNITS, value, actionTypes.SETTINGS_SAVE_FORMULA_UNITS);

export const setFtsEnabled = (value) => getSettingRequest(settings.FTS, value, actionTypes.SETTINGS_SAVE_FTS);

export const setGenerateColorPreview = (value) =>
    getSettingRequest(settings.GENERATE_COLOR_PREVIEW, value, actionTypes.SETTINGS_SAVE_GENERATE_COLOR_PREVIEW);

export const setHelperAutoDownload = (value) =>
    getSettingRequest(settings.HELPER_AUTO_DOWNLOAD, value, actionTypes.SETTINGS_SAVE_HELPER_AUTO_DOWNLOAD);

export const setHelperAutoForceInstall = (value) =>
    getSettingRequest(settings.HELPER_AUTO_FORCE_INSTALL, value, actionTypes.SETTINGS_SAVE_HELPER_AUTO_FORCE_INSTALL);

export const setHelperAutoCheck = (value) =>
    getSettingRequest(settings.HELPER_AUTO_CHECK, value, actionTypes.SETTINGS_SAVE_HELPER_AUTO_CHECK);

export const setHelperAutoCheckInterval = (value) =>
    getSettingRequest(settings.HELPER_AUTO_CHECK_INTERVAL, value, actionTypes.SETTINGS_SAVE_HELPER_AUTO_CHECK_INTERVAL);

export const setHelperAutoInstall = (value) =>
    getSettingRequest(settings.HELPER_AUTO_INSTALL, value, actionTypes.SETTINGS_SAVE_HELPER_AUTO_INSTALL);

export const setHelperAutoInstallDelay = (value) =>
    getSettingRequest(settings.HELPER_AUTO_INSTALL_DELAY, value, actionTypes.SETTINGS_SAVE_HELPER_AUTO_INSTALL_DELAY);

export const setHelperAutoInstallNewDbs = (value) =>
    getSettingRequest(
        settings.HELPER_AUTO_INSTALL_NEW_DBS,
        value,
        actionTypes.SETTINGS_SAVE_HELPER_AUTO_INSTALL_NEW_DBS
    );

export const setHelperAutoInstallNightCheck = (value) =>
    getSettingRequest(settings.HELPER_AUTO_NIGHT_CHECK, value, actionTypes.SETTINGS_SAVE_HELPER_AUTO_NIGHT_CHECK);

export const setHelperAutoRebootDelay = (value) =>
    getSettingRequest(settings.HELPER_AUTO_REBOOT_DELAY, value, actionTypes.SETTINGS_SAVE_HELPER_AUTO_REBOOT_DELAY);

export const setHelpLink = (value) => getSettingRequest(settings.HELP_LINK, value, actionTypes.SETTINGS_SAVE_HELP_LINK);

export const setHelpSettings = (value) => getSettingRequest(settings.HELP, value, actionTypes.SETTINGS_SAVE_HELP);

export const setHistoricalFormulasPosition = (value) =>
    getSettingRequest(
        settings.HISTORICAL_FORMULAS_POSITION,
        value,
        actionTypes.SETTINGS_SAVE_HISTORICAL_FORMULAS_POSITION
    );

export const setImagesSource = (value) =>
    getSettingRequest(settings.IMAGES_SOURCE, value, actionTypes.SETTINGS_SAVE_IMAGES_SOURCE);

export const setInfoPanelResizable = (value) =>
    getSettingRequest(settings.INFO_PANEL_RESIZABLE, value, actionTypes.SETTINGS_SAVE_INFO_PANEL_RESIZABLE);

export const setInfoPanelTab = (value) =>
    getSettingRequest(settings.INFO_PANEL_TAB, value, actionTypes.SETTINGS_SAVE_INFO_PANEL_TAB);

export const setInitialTabType = (value) =>
    getSettingRequest(settings.INIT_TAB_TYPE, value, actionTypes.SETTINGS_SAVE_INITIAL_TAB_TYPE);

export const setIntergammaColorFandeckWizard = (value) =>
    getSettingRequest(settings.INTERGAMMA_COLOR_FANDECK_WIZARD, value, actionTypes.SETTINGS_SAVE_COLOR_FANDECK_WIZARD);

export const setIntergammaMachineOrderSorting = (value) =>
    getSettingSetRequest(
        settings.INTERGAMMA_MACHINE_SORTING_ORDERS,
        value,
        handlers.SETTINGS_GET_INTERGAMMA_MACHINE_SORTING_ORDERS
    );

export const setKeyboard = (value) => getSettingRequest(settings.KEYBOARD, value, actionTypes.SETTINGS_SAVE_KEYBOARD);

export const setKeyboardShortcuts = (value) =>
    getSettingRequest(settings.KEYBOARD_SHORTCUTS, value, actionTypes.SETTINGS_SAVE_KEYBOARD_SHORTCUTS);

export const setKiosk = (value) => getSettingRequest(settings.KIOSK, value, actionTypes.SETTINGS_SAVE_KIOSK);

export const setLastUsedUnit = (value) =>
    getSettingRequest(settings.ACTIVE_FORMULA_UNIT, value, actionTypes.SETTINGS_SAVE_ACTIVE_FORMULA_UNIT);

export const setLightAtStartup = (value) => ({
    type: actionTypes.SETTINGS_SAVE_LIGHT_AT_STARTUP,
    payload: {
        value: value
    }
});

export const setRedlikeLightEnabled = (value) =>
    getSettingRequest(settings.LIGHT_ENABLED, value, actionTypes.SETTINGS_SAVE_REDLIKE_LIGHT_ENABLED);

export const setLocale = (value) => getSettingSetRequest(settings.LOCALE, value, handlers.SETTINGS_GET_LOCALE);

export const setLockComputer = (value) =>
    getSettingSetRequest(settings.LOCK_COMPUTER, value, handlers.SETTINGS_GET_LOCK_COMPUTER);

export const setManualAdditionUnit = (value) =>
    getSettingRequest(settings.SETTINGS_MANUAL_ADDITION_UNIT, value, actionTypes.SETTINGS_SAVE_MANUAL_ADDITION_UNIT);

export const setMasterProductSiblingsTable = (value) =>
    getSettingRequest(
        settings.MASTER_PRODUCT_SIBLINGS_TABLE,
        value,
        actionTypes.SETTINGS_SAVE_MASTER_PRODUCT_SIBLINGS_TABLE
    );

export const setMatchingInfoCr = (value) =>
    getSettingRequest(settings.MATCHING_INFO_CR, value, actionTypes.SETTINGS_SAVE_MATCHING_INFO_CR);

export const setMatchingInfoDeltaE1 = (value) =>
    getSettingRequest(settings.MATCHING_INFO_DELTA_E1, value, actionTypes.SETTINGS_SAVE_MATCHING_INFO_DELTA_E1);

export const setMatchingInfoDeltaE2 = (value) =>
    getSettingRequest(settings.MATCHING_INFO_DELTA_E2, value, actionTypes.SETTINGS_SAVE_MATCHING_INFO_DELTA_E2);

export const setMatchingInfoDeltaE3 = (value) =>
    getSettingRequest(settings.MATCHING_INFO_DELTA_E3, value, actionTypes.SETTINGS_SAVE_MATCHING_INFO_DELTA_E3);

export const setMatchingInfoDin = (value) =>
    getSettingRequest(settings.MATCHING_INFO_DIN, value, actionTypes.SETTINGS_SAVE_MATCHING_INFO_DIN);

export const setMatchingInfoLrv = (value) =>
    getSettingRequest(settings.MATCHING_INFO_LRV, value, actionTypes.SETTINGS_SAVE_MATCHING_INFO_LRV);

export const setMatchingInfoRms = (value) =>
    getSettingRequest(settings.MATCHING_INFO_RMS, value, actionTypes.SETTINGS_SAVE_MATCHING_INFO_RMS);

export const setMatchingOptionsColorants = (value) =>
    getSettingRequest(settings.MATCHING_OPTIONS_COLORANTS, value, actionTypes.SETTINGS_SAVE_MATCHING_OPTIONS_COLORANTS);

export const setMatchingOptionsColorfile = (value) =>
    getSettingRequest(settings.MATCHING_OPTIONS_COLORFILE, value, actionTypes.SETTINGS_SAVE_MATCHING_OPTIONS_COLORFILE);

export const setMatchingOptionsSortResults = (value) =>
    getSettingRequest(
        settings.MATCHING_OPTIONS_SORT_RESULTS,
        value,
        actionTypes.SETTINGS_SAVE_MATCHING_OPTIONS_SORT_RESULTS
    );

export const setMatchingRowCount = (value) =>
    getSettingRequest(settings.MATCHING_ROW_COUNT, value, actionTypes.SETTINGS_SAVE_MATCHING_ROW_COUNT);

export const setMatchingTableBase = (value) =>
    getSettingRequest(settings.MATCHING_TABLE_BASE, value, actionTypes.SETTINGS_SAVE_MATCHING_TABLE_BASE);

export const setMatchingTableColorants = (value) =>
    getSettingRequest(settings.MATCHING_TABLE_COLORANTS, value, actionTypes.SETTINGS_SAVE_MATCHING_TABLE_COLORANTS);

export const setMatchingTableCr = (value) =>
    getSettingRequest(settings.MATCHING_TABLE_CR, value, actionTypes.SETTINGS_SAVE_MATCHING_TABLE_CR);

export const setMatchingTableDeltaE1 = (value) =>
    getSettingRequest(settings.MATCHING_TABLE_DELTA_E1, value, actionTypes.SETTINGS_SAVE_MATCHING_TABLE_DELTA_E1);

export const setMatchingTableDeltaE2 = (value) =>
    getSettingRequest(settings.MATCHING_TABLE_DELTA_E2, value, actionTypes.SETTINGS_SAVE_MATCHING_TABLE_DELTA_E2);

export const setMatchingTableDeltaE3 = (value) =>
    getSettingRequest(settings.MATCHING_TABLE_DELTA_E3, value, actionTypes.SETTINGS_SAVE_MATCHING_TABLE_DELTA_E3);

export const setMatchingTableDin = (value) =>
    getSettingRequest(settings.MATCHING_TABLE_DIN, value, actionTypes.SETTINGS_SAVE_MATCHING_TABLE_DIN);

export const setMatchingTableLrv = (value) =>
    getSettingRequest(settings.MATCHING_TABLE_LRV, value, actionTypes.SETTINGS_SAVE_MATCHING_TABLE_LRV);

export const setMatchingTablePrice = (value) =>
    getSettingRequest(settings.MATCHING_TABLE_PRICE, value, actionTypes.SETTINGS_SAVE_MATCHING_TABLE_PRICE);

export const setMatchingTableRms = (value) =>
    getSettingRequest(settings.MATCHING_TABLE_RMS, value, actionTypes.SETTINGS_SAVE_MATCHING_TABLE_RMS);

export const setMaxNumberOfTabs = (value) =>
    getSettingRequest(settings.NUMBER_OF_TABS, value, actionTypes.SETTINGS_SAVE_NUMBER_OF_TABS);

export const setMaxToleranceForCompetitiveColors = (value) =>
    getSettingRequest(
        settings.MAX_TOLERANCE_FOR_COMPETITIVE_COLORS,
        value,
        actionTypes.SETTINGS_SAVE_MAX_TOLERANCE_OF_COMPETITIVE_COLORS
    );

export const setMoreInfoInternalEnabled = (value) =>
    getSettingRequest(settings.MORE_INFO_INTERNAL, value, actionTypes.SETTINGS_SAVE_MORE_INFO_INTERNAL);

export const setNavigationItems = (value) =>
    getSettingSetRequest(settings.NAVIGATION_ITEMS, value, handlers.SETTINGS_GET_NAVIGATION_ITEMS);

export const setNumberOfCompetitiveColors = (value) =>
    getSettingRequest(
        settings.NUMBER_OF_COMPETITIVE_COLORS,
        value,
        actionTypes.SETTINGS_SAVE_NUMBER_OF_COMPETITIVE_COLORS
    );

export const setOrderingEnabled = (value) =>
    getSettingRequest(settings.ORDERING_ENABLED, value, actionTypes.SETTINGS_SAVE_ORDERING_ENABLED);

export const setOrderModalEnabled = (value) =>
    getSettingRequest(settings.ORDER_MODAL_ENABLED, value, actionTypes.SETTINGS_SAVE_ORDER_MODAL_ENABLED);

export const setOrderSearchItems = (value) =>
    getSettingSetRequest(settings.ORDER_SEARCH_ITEMS, value, handlers.SETTINGS_GET_ORDER_SEARCH_ITEMS);

export const setOverwriteLastTab = (value) =>
    getSettingRequest(settings.OVERWRITE_LAST_TAB, value, actionTypes.SETTINGS_SAVE_OVERWRITE_LAST_TAB);

export const setPriceTypes = (value) =>
    getSettingSetRequest(settings.PRICE_TYPES, value, handlers.SETTINGS_GET_PRICE_TYPES);

export const setVatVisibility = (value) =>
    getSettingRequest(settings.PRICE_VISIBILITY_TYPES, value, actionTypes.SETTINGS_SAVE_PRICE_VISIBILITY_TYPE);

export const setPricingEnabled = (value) =>
    getSettingRequest(settings.PRICING_ENABLED, value, actionTypes.SETTINGS_SAVE_PRICING_ENABLED);

export const setPrintAfterDispensing = (value) =>
    getSettingRequest(settings.PRINT_AFTER_DISPENSING, value, actionTypes.SETTINGS_SAVE_PRINT_AFTER_DISPENSING);

export const setPrintAsImage = (value) =>
    getSettingRequest(settings.PRINT_AS_IMAGE, value, actionTypes.SETTINGS_SAVE_PRINT_AS_IMAGE);

export const setPrintBeforeDispensing = (value) =>
    getSettingRequest(settings.PRINT_BEFORE_DISPENSING, value, actionTypes.SETTINGS_SAVE_PRINT_BEFORE_DISPENSING);

export const setPrintEnabled = (value) =>
    getSettingRequest(settings.PRINT_ENABLED, value, actionTypes.SETTINGS_SAVE_PRINT_ENABLED);

export const setDefaultPrinter = (value) =>
    getSettingRequest(settings.PRINTER, value, actionTypes.SETTINGS_SAVE_DEFAULT_PRINTER);

export const setDefaultTemplate = (value) =>
    getSettingRequest(settings.PRINTER_TEMPLATE, value, actionTypes.SETTINGS_SAVE_DEFAULT_TEMPLATE);

export const setFandeckGroups = (value) =>
    getSettingRequest(settings.FANDECK_GROUPS, value, actionTypes.SETTINGS_SAVE_FANDECK_GROUPS);

export const setQuickTintTemplate = (value) =>
    getSettingRequest(settings.PRINTER_TEMPLATE_QUICKTINT, value, actionTypes.SETTINGS_SAVE_DEFAULT_TEMPLATE_QUICKTINT);

export const setPrintOnRequest = (value) =>
    getSettingRequest(settings.PRINT_ON_REQUEST, value, actionTypes.SETTINGS_SAVE_PRINT_ON_REQUEST);

export const setPrintTasksAfterDispensing = (value) =>
    getSettingRequest(
        settings.PRINT_TASKS_AFTER_DISPENSING,
        value,
        actionTypes.SETTINGS_SAVE_PRINT_TASKS_AFTER_DISPENSING
    );

export const setPrintTasksBeforeDispensing = (value) =>
    getSettingRequest(
        settings.PRINT_TASKS_BEFORE_DISPENSING,
        value,
        actionTypes.SETTINGS_SAVE_PRINT_TASKS_BEFORE_DISPENSING
    );

export const setProductCode = (value) =>
    getSettingRequest(settings.PRODUCT_CODE, value, actionTypes.SETTINGS_SAVE_PRODUCT_CODE);

export const setProductFilesSource = (value) =>
    getSettingRequest(settings.PRODUCT_FILES_SOURCE, value, actionTypes.SETTINGS_SAVE_PRODUCT_FILES_SOURCE);

export const setProductGroups = (value) =>
    getSettingRequest(settings.PRODUCT_GROUPS, value, actionTypes.SETTINGS_SAVE_PRODUCT_GROUPS);

export const setProductImagePreviewEnabled = (value) =>
    getSettingRequest(settings.PRODUCT_IMAGE_PREVIEW, value, actionTypes.SETTINGS_SAVE_PRODUCT_IMAGE_PREVIEW_ENABLED);

export const setQualityControlColorDifference = (value) =>
    getSettingRequest(
        settings.QUALITY_CONTROL_COLOR_DIFFERENCE,
        value,
        actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_COLOR_DIFFERENCE
    );

export const setQualityControlDeltaA = (value) =>
    getSettingRequest(settings.QUALITY_CONTROL_DELTA_A, value, actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_DELTA_A);

export const setQualityControlDeltaB = (value) =>
    getSettingRequest(settings.QUALITY_CONTROL_DELTA_B, value, actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_DELTA_B);

export const setQualityControlDeltaE = (value) =>
    getSettingRequest(settings.QUALITY_CONTROL_DELTA_E, value, actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_DELTA_E);

export const setQualityControlEnabled = (value) =>
    getSettingRequest(settings.QUALITY_CONTROL_ENABLED, value, actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_ENABLED);

export const setQualityControlDeltaL = (value) =>
    getSettingRequest(settings.QUALITY_CONTROL_DELTA_L, value, actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_DELTA_L);

export const setQualityControlMetamerism = (value) =>
    getSettingRequest(settings.QUALITY_CONTROL_METAMERISM, value, actionTypes.SETTINGS_SAVE_QUALITY_CONTROL_METAMERISM);

export const setQuickTintSorting = (value) =>
    getSettingRequest(settings.QUICK_TINT_SORTING_TYPE, value, actionTypes.SETTINGS_SAVE_QUICK_TINT_SORTING_TYPE);

export const setQuickTintWindowClosingRule = (value) =>
    getSettingRequest(
        settings.QUICK_TINT_WINDOW_CLOSE_AFTER_DISPENSING,
        value,
        actionTypes.SETTINGS_SAVE_QUICK_TINT_WINDOW_CLOSING_RULE
    );

export const setRccBarcodeRefill = (value) =>
    getSettingRequest(settings.RCC_BARCODE_REFILL, value, actionTypes.SETTINGS_SAVE_RCC_BARCODE_REFILL);

export const setRccBaseCanBarcodeValidation = (value) =>
    getSettingRequest(
        settings.RCC_BASE_CAN_BARCODE_VALIDATION,
        value,
        actionTypes.SETTINGS_SAVE_RCC_BASE_CAN_BARCODE_VALIDATION
    );

export const setRccDispenseInvalidColorants = (value) =>
    getSettingRequest(
        settings.RCC_DISPENSE_INVALID_COLORANTS,
        value,
        actionTypes.SETTINGS_SAVE_RCC_DISPENSE_INVALID_COLORANTS
    );

export const setRccCheckCanBeforeDispense = (value) =>
    getSettingRequest(
        settings.RCC_CHECK_CAN_BEFORE_DISPENSE,
        value,
        actionTypes.SETTINGS_SAVE_RCC_CHECK_CAN_BEFORE_DISPENSE
    );

export const setRccCheckOverfill = (value) =>
    getSettingRequest(settings.RCC_CHECK_OVERFILL, value, actionTypes.SETTINGS_SAVE_RCC_CHECK_OVERFILL);

export const setRccManualColorantAddition = (value) =>
    getSettingRequest(
        settings.RCC_MANUAL_COLORANT_ADDITION,
        value,
        actionTypes.SETTINGS_SAVE_RCC_MANUAL_COLORANT_ADDITION
    );

export const setRccMinimalDispenseAmount = (value) =>
    getSettingRequest(
        settings.RCC_MINIMAL_DISPENSE_AMOUNT,
        value,
        actionTypes.SETTINGS_SAVE_RCC_MINIMAL_DISPENSE_AMOUNT
    );

export const setRccPlaceCanSensor = (value) =>
    getSettingRequest(settings.RCC_PLACE_CAN_SENSOR, value, actionTypes.SETTINGS_SAVE_RCC_PLACE_CAN_SENSOR);

export const setRccPlaceCanSensorDelay = (value) =>
    getSettingRequest(settings.RCC_PLACE_CAN_SENSOR_DELAY, value, actionTypes.SETTINGS_SAVE_RCC_PLACE_CAN_SENSOR_DELAY);

export const setRccRemoveCanSensor = (value) =>
    getSettingRequest(settings.RCC_REMOVE_CAN_SENSOR, value, actionTypes.SETTINGS_SAVE_RCC_REMOVE_CAN_SENSOR);

export const setRccRemoveCanSensorDelay = (value) =>
    getSettingRequest(
        settings.RCC_REMOVE_CAN_SENSOR_DELAY,
        value,
        actionTypes.SETTINGS_SAVE_RCC_REMOVE_CAN_SENSOR_DELAY
    );

export const setRccSkipPlaceCanDialog = (value) =>
    getSettingRequest(settings.RCC_SKIP_PLACE_CAN_DIALOG, value, actionTypes.SETTINGS_SAVE_RCC_SKIP_PLACE_CAN_DIALOG);

export const setRccSkipRemoveCanDialog = (value) =>
    getSettingRequest(settings.RCC_SKIP_REMOVE_CAN_DIALOG, value, actionTypes.SETTINGS_SAVE_RCC_SKIP_REMOVE_CAN_DIALOG);

export const setRccSplitFormula = (value) =>
    getSettingRequest(settings.RCC_SPLIT_FORMULA, value, actionTypes.SETTINGS_SAVE_RCC_SPLIT_FORMULA);

export const setRccTmcEnabled = (value) =>
    getSettingRequest(settings.RCC_TMC_ENABLED, value, actionTypes.SETTINGS_SAVE_RCC_TMC_ENABLED);

export const setRccUnit = (value) => getSettingRequest(settings.RCC_UNIT, value, actionTypes.SETTINGS_SAVE_RCC_UNIT);

export const setRccValidateColorantsDuringInit = (value) =>
    getSettingRequest(
        settings.RCC_VALIDATE_COLORANTS_DURING_INIT,
        value,
        actionTypes.SETTINGS_SAVE_RCC_VALIDATE_COLORANTS_DURING_INIT
    );

export const setRecirculationSpeed = (value) =>
    getSettingRequest(settings.RECIRCULATION_SPEED, value, actionTypes.SETTINGS_SAVE_RECIRCULATION_SPEED);

export const setRecirculationTime = (value) =>
    getSettingRequest(settings.RECIRCULATION_TIME, value, actionTypes.SETTINGS_SAVE_RECIRCULATION_TIME);

export const setRounding = (value) => getSettingRequest(settings.ROUNDING, value, actionTypes.SETTINGS_SAVE_ROUNDING);

export const setScreensaverTimeout = (value) =>
    getSettingRequest(settings.SCREENSAVER_TIMEOUT, value, actionTypes.SETTINGS_SAVE_SCREENSAVER_TIMEOUT);

export const setSearchCheaperColors = (value) =>
    getSettingRequest(settings.SEARCH_CHEAPER_COLORS, value, actionTypes.SETTINGS_SAVE_SEARCH_CHEAPER_COLORS);

export const setSearchPanelBase = (value) =>
    getSettingSetRequest(settings.SEARCH_PANEL_BASE, value, handlers.SETTINGS_GET_SEARCH_PANEL_BASE);

export const setSearchPanelBaseSize = (value) =>
    getSettingRequest(settings.SEARCH_PANEL_BASE_SIZE, value, actionTypes.SETTINGS_SAVE_SEARCH_PANEL_BASE_SIZE);

export const setSearchPanelBipp = (value) =>
    getSettingSetRequest(settings.SEARCH_PANEL_BIPP, value, handlers.SETTINGS_GET_SEARCH_PANEL_BIPP);

export const setSearchPanelBippSize = (value) =>
    getSettingRequest(settings.SEARCH_PANEL_BIPP_SIZE, value, actionTypes.SETTINGS_SAVE_SEARCH_PANEL_BIPP_SIZE);

export const setSearchPanelDropDownCalculate = (value) =>
    getSettingRequest(
        settings.SEARCH_PANEL_DROP_DOWN_CALCULATE,
        value,
        actionTypes.SETTINGS_SAVE_SEARCH_PANEL_DROP_DOWN_CALCULATE
    );

export const setSearchPanelFandeckSize = (value) =>
    getSettingRequest(settings.SEARCH_PANEL_FANDECK_SIZE, value, actionTypes.SETTINGS_SAVE_SEARCH_PANEL_FANDECK_SIZE);

export const setSearchPanelFormulaSize = (value) =>
    getSettingRequest(settings.SEARCH_PANEL_FORMULA_SIZE, value, actionTypes.SETTINGS_SAVE_SEARCH_PANEL_FORMULA_SIZE);

export const setSearchPanelOrder = (value) =>
    getSettingRequest(settings.SEARCH_PANEL_ORDER, value, actionTypes.SETTINGS_SAVE_SEARCH_PANEL_ORDER);

export const setSearchPanelOrderByDistance = (value) =>
    getSettingRequest(
        settings.SEARCH_PANEL_ORDER_BY_DISTANCE,
        value,
        actionTypes.SETTINGS_SAVE_SEARCH_PANEL_ORDER_BY_DISTANCE
    );

export const setSearchPanelProduct = (value) =>
    getSettingSetRequest(settings.SEARCH_PANEL_PRODUCT, value, handlers.SETTINGS_GET_SEARCH_PANEL_PRODUCT);

export const setSearchPanelProductSize = (value) =>
    getSettingRequest(settings.SEARCH_PANEL_PRODUCT_SIZE, value, actionTypes.SETTINGS_SAVE_SEARCH_PANEL_PRODUCT_SIZE);

export const setSearchPanelQuickSelect = (value) =>
    getSettingSetRequest(settings.SEARCH_PANEL_QUICK_SELECT, value, handlers.SETTINGS_GET_SEARCH_PANEL_QUICK_SELECT);

export const setSoundEnabled = (value) =>
    getSettingRequest(settings.SOUND_ENABLED, value, actionTypes.SETTINGS_SAVE_SOUND_ENABLED);

export const setSpectroEnabled = (value) =>
    getSettingSetRequest(settings.SPECTRO_ENABLED, value, handlers.SETTINGS_GET_SPECTRO_ENABLED);

export const setStirringSpeed = (value) =>
    getSettingRequest(settings.STIRRING_SPEED, value, actionTypes.SETTINGS_SAVE_STIRRING_SPEED);

export const setStirringTime = (value) =>
    getSettingRequest(settings.STIRRING_TIME, value, actionTypes.SETTINGS_SAVE_STIRRING_TIME);

export const setStockDatabaseFilter = (value) =>
    getSettingRequest(settings.STOCK_DATABASE_FILTER, value, actionTypes.SETTINGS_SAVE_STOCK_DATABASE_FILTER);

export const setStockTableOrderBy = (value) =>
    getSettingRequest(settings.STOCK_TABLE_ORDER_BY, value, actionTypes.SETTINGS_SAVE_STOCK_TABLE_ORDER_BY);

export const setTableAnswer = (value) =>
    getSettingRequest(settings.TABLE_ANSWER, value, actionTypes.SETTINGS_SAVE_TABLE_ANSWER);

export const setTableBase = (value) =>
    getSettingRequest(settings.TABLE_BASE, value, actionTypes.SETTINGS_SAVE_TABLE_BASE);

export const setTableBipp = (value) =>
    getSettingRequest(settings.TABLE_BIPP, value, actionTypes.SETTINGS_SAVE_TABLE_BIPP);

export const setTableBuildingSite = (value) =>
    getSettingRequest(settings.TABLE_BUILDING_SITE, value, actionTypes.SETTINGS_SAVE_TABLE_BUILDING_SITE);

export const setTableClientName = (value) =>
    getSettingRequest(settings.TABLE_CLIENT_NAME, value, actionTypes.SETTINGS_SAVE_TABLE_CLIENT_NAME);

export const setTableColorName = (value) =>
    getSettingRequest(settings.TABLE_COLOR_NAME, value, actionTypes.SETTINGS_SAVE_TABLE_COLOR_NAME);

export const setTableComment = (value) =>
    getSettingRequest(settings.TABLE_COMMENT, value, actionTypes.SETTINGS_SAVE_TABLE_COMMENT);

export const setTableCreated = (value) =>
    getSettingRequest(settings.TABLE_CREATED, value, actionTypes.SETTINGS_SAVE_TABLE_CREATED);

export const setTableCustomer = (value) =>
    getSettingRequest(settings.TABLE_CUSTOMER, value, actionTypes.SETTINGS_SAVE_TABLE_CUSTOMER);

export const setTableDate = (value) =>
    getSettingRequest(settings.TABLE_DATE, value, actionTypes.SETTINGS_SAVE_TABLE_DATE);

export const setTableFandeck = (value) =>
    getSettingRequest(settings.TABLE_FANDECK, value, actionTypes.SETTINGS_SAVE_TABLE_FANDECK);

export const setTableFormulaCode = (value) =>
    getSettingRequest(settings.TABLE_FORMULA_CODE, value, actionTypes.SETTINGS_SAVE_TABLE_FORMULA_CODE);

export const setTableFormulaName = (value) =>
    getSettingRequest(settings.TABLE_FORMULA_NAME, value, actionTypes.SETTINGS_SAVE_TABLE_FORMULA_NAME);

export const setTableMoreInfo = (value) =>
    getSettingRequest(settings.TABLE_MORE_INFO, value, actionTypes.SETTINGS_SAVE_TABLE_MORE_INFO);

export const setTableMoreInfoInternal = (value) =>
    getSettingRequest(settings.TABLE_MORE_INFO_INTERNAL, value, actionTypes.SETTINGS_SAVE_TABLE_MORE_INFO_INTERNAL);

export const setTableOperator = (value) =>
    getSettingRequest(settings.TABLE_OPERATOR, value, actionTypes.SETTINGS_SAVE_TABLE_OPERATOR);

export const setTablePackage = (value) =>
    getSettingRequest(settings.TABLE_PACKAGE, value, actionTypes.SETTINGS_SAVE_TABLE_PACKAGE);

export const setTableProduct = (value) =>
    getSettingRequest(settings.TABLE_PRODUCT, value, actionTypes.SETTINGS_SAVE_TABLE_PRODUCT);

export const setTableQualityControl = (value) =>
    getSettingRequest(settings.TABLE_QUALITY_CONTROL, value, actionTypes.SETTINGS_SAVE_TABLE_QUALITY_CONTROL);

export const setTableQuantity = (value) =>
    getSettingRequest(settings.TABLE_QUANTITY, value, actionTypes.SETTINGS_SAVE_TABLE_QUANTITY);

export const setTableStatus = (value) =>
    getSettingRequest(settings.TABLE_STATUS, value, actionTypes.SETTINGS_SAVE_TABLE_STATUS);

export const setTableSubject = (value) =>
    getSettingRequest(settings.TABLE_SUBJECT, value, actionTypes.SETTINGS_SAVE_TABLE_SUBJECT);

export const setTableTicketId = (value) =>
    getSettingRequest(settings.TABLE_TICKET_ID, value, actionTypes.SETTINGS_SAVE_TABLE_TICKET_ID);

export const setTableType = (value) =>
    getSettingRequest(settings.TABLE_TYPE, value, actionTypes.SETTINGS_SAVE_TABLE_TYPE);

export const setTabsEnabled = (value) =>
    getSettingSetRequest(settings.TABS_ENABLED, value, handlers.SETTINGS_GET_TABS_ENABLED);

export const setTabsMemory = (value) =>
    getSettingRequest(settings.TABS_MEMORY, value, actionTypes.SETTINGS_SAVE_TABS_MEMORY);

export const setTintometricSystem = (value) =>
    getSettingSetRequest(settings.TINTOMETRIC_SYSTEM, value, handlers.SETTINGS_GET_TINTOMETRIC_SYSTEM);

export const setUfiCodeBaseValidation = (value) =>
    getSettingSetRequest(settings.UFI_CODE_BASE_VALIDATION, value, handlers.SETTINGS_GET_UFI_CODE_BASE_VALIDATION);

export const setUfiCodeLogic = (value) =>
    getSettingSetRequest(settings.UFI_CODE_LOGIC, value, handlers.SETTINGS_GET_UFI_CODE_LOGIC);

export const setUfiCodeMinAmountGravPercent = (value) =>
    getSettingRequest(
        settings.UFI_CODE_MIN_AMOUNT_GRAV_PERCENT,
        value,
        actionTypes.SETTINGS_SAVE_UFI_CODE_MIN_AMOUNT_GRAV_PERCENT
    );

export const setUfiCodeMinGravPercent = (value) =>
    getSettingRequest(settings.UFI_CODE_MIN_GRAV_PERCENT, value, actionTypes.SETTINGS_SAVE_UFI_CODE_MIN_GRAV_PERCENT);

export const setUserIdentificationEnabled = (value) =>
    getSettingRequest(settings.USER_IDENTIFICATION, value, actionTypes.SETTINGS_SAVE_USER_IDENTIFICATION);

export const setValidateColorantBaseRules = (value) =>
    getSettingRequest(
        settings.VALIDATE_COLORANT_BASE_RULES,
        value,
        actionTypes.SETTINGS_SAVE_VALIDATE_COLORANT_BASE_RULES
    );

export const setValidateMinDosableAmount = (value) =>
    getSettingRequest(
        settings.VALIDATE_MIN_DOSABLE_AMOUNT,
        value,
        actionTypes.SETTINGS_SAVE_VALIDATE_MIN_DOSABLE_AMOUNT
    );

export const setValidateOverfill = (value) =>
    getSettingRequest(settings.VALIDATE_OVERFILL, value, actionTypes.SETTINGS_SAVE_VALIDATE_OVERFILL);

export const setValidateTotalCntAmounts = (value) =>
    getSettingRequest(settings.VALIDATE_TOTAL_CNT_AMOUNTS, value, actionTypes.SETTINGS_SAVE_VALIDATE_TOTAL_CNT_AMOUNTS);

export const setVirtualKeyboardEnabled = (value) =>
    getSettingRequest(settings.VIRTUAL_KEYBOARD_ENABLED, value, actionTypes.SETTINGS_SAVE_VIRTUAL_KEYBOARD_ENABLED);

export const setVisibleUnits = (value) =>
    getSettingSetRequest(settings.VISIBLE_UNITS, value, handlers.SETTINGS_GET_VISIBLE_UNITS);

export const setZoom = (value) => getSettingRequest(settings.ZOOM, value, actionTypes.SETTINGS_SAVE_ZOOM);
